import { BillingFrequency } from '../../../../contracts';

export function subscriptionUnitToText(frequency: BillingFrequency | undefined) {
  return frequency ?? '';
}
